import { Sort } from "../types";

/**
 * Generates an order query string based on the provided sorting criteria.
 *
 * @param {Sort} sort - An array of sorting criteria.
 * @returns {string} The order query string.
 */
export default function getOrderByQuery(sort: Sort) {
  let orderQuery = "";
  if (sort.length === 0) {
    return "";
  }
  if (sort[0].desc === false) {
    orderQuery = `${sort[0].id}:asc`;
  } else {
    orderQuery = `${sort[0].id}:desc`;
  }
  return orderQuery;
}
